var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M3.91 7.065v7.688c.01.563.234 1.099.627 1.493.392.395.92.616 1.472.616.55 0 1.079-.221 1.472-.616.392-.394.617-.93.626-1.493l.006-10.078a3.698 3.698 0 0 0-.258-1.403 3.639 3.639 0 0 0-.768-1.193 3.554 3.554 0 0 0-1.159-.798 3.493 3.493 0 0 0-2.742 0 3.554 3.554 0 0 0-1.16.798c-.33.342-.591.748-.767 1.193A3.698 3.698 0 0 0 1 4.675v10.146a5.2 5.2 0 0 0 .36 1.976c.246.628.613 1.2 1.078 1.682.465.482 1.02.864 1.63 1.125a4.911 4.911 0 0 0 3.861 0 4.996 4.996 0 0 0 1.631-1.125 5.117 5.117 0 0 0 1.079-1.682 5.2 5.2 0 0 0 .36-1.976v-9.48"
  })));
};
export default SvgAttach;